import { CURRENCY } from "../../constants/app-constants";
import priceFormatter from "./price-formatter";

const makePriceLabel = (price, currency = CURRENCY.AU) => `${currency}${priceFormatter(price, true, currency)}`;

export const makePriceLabelRound = (price = 0, currency = CURRENCY.AU) => {
    return makePriceLabel(Math.round(price), currency);
};

export const makePriceRangeLabel = (price = 0, currency = CURRENCY.AU) => {
    const maxPrice = Number(price || 0);

    if (!maxPrice) {
        return makePriceLabelRound(price, currency);
    }
    /* eslint-disable-next-line no-magic-numbers */
    return `${makePriceLabelRound(maxPrice * 0.95, currency)} - ${makePriceLabelRound(maxPrice, currency)}`;
};

export default makePriceLabel;
